import React from 'react';
import {Router, Route, Switch} from 'react-router-dom';
import history from './helper/history';
// non-react import
import EpflHeader from './helper/EpflHeader';
import EpflFooter from './helper/EpflFooter';
import AppExample from './helper/AppExample';
import SmlmPreview from './smlmPreview/SmlmPreview.jsx';
import SoftwareList from './softwareList/SoftwareList';
import SubmitSoftware from './softwareList/SubmitSoftware';
import SubmitResults from './challenge/SubmitResults';
import ChallengeSimulatedData from './challenge/ChallengeSimulatedData';
import ChallengeRealData from './challenge/ChallengeRealData';
import ChallengeRealDataResults from './challenge/ChallengeRealDataResults'
import ChallengeSoftwareInfo from './challenge/ChallengeSoftwareInfo';
import ChallengeSoftwareResults from './challenge/ChallengeSoftwareResults';
import Challenge2013 from './challenge/Challenge2013';
import Challenge from './challenge/Challenge';
import AboutChallenge from './challenge/AboutChallenge';
import ChallengeMethod from './challenge/ChallengeMethod';
import DatasetPage from './datasetsPage/DatasetPage';
import Datasets from './datasets/Datasets';
import NotFound from './helper/NotFound';
import HomePage from './HomePage';
import Feedback from './helper/Feedback';
import Metrics from './metrics/Metrics';
import ImDecorr from './metrics/ImDecorr';
import VirtualSMLM from './virtualSMLM/VirtualSMLM';
import ApplicationCase from './applicationCase/ApplicationCase';
import TestFlask from './helper/TestFlask';

import website from './dataStruct/websiteStruct.json';


// App is the main container of the website: header, body and footer
// Header contains the general menu /links to subpages for navigations
// Body is the playground for dynamic rendering of data / json
// Footer is the standard EPFL footer with usual links

// Map a string to a react component
const COMPONENT_MAP = {
  'HomePage': HomePage,
  'AppExample': AppExample,
  'SoftwareList': SoftwareList,
  'SubmitSoftware': SubmitSoftware,
  'SubmitResults': SubmitResults,
  'ChallengeSimulatedData': ChallengeSimulatedData,
  'ChallengeRealData':ChallengeRealData,
  'ChallengeRealDataResults':ChallengeRealDataResults,
  'Challenge2013': Challenge2013,
  'Challenge': Challenge,
  'AboutChallenge':AboutChallenge,
  'ChallengeMethod':ChallengeMethod,
  'Datasets':Datasets,
  'SmlmPreview':SmlmPreview,
  'Metrics':Metrics,
  'VirtualSMLM':VirtualSMLM,
  'ApplicationCase':ApplicationCase,
  'ImDecorr':ImDecorr
}

let websitePageList = [];
let websiteComponentList = [];
  website.forEach( (page) => {
      websitePageList.push(page['path']);
      websiteComponentList.push(page['component']);
      if (page['children'].length > 0) {
        page['children'].forEach ( (subpage) => {
          websitePageList.push(page['path'] + subpage['path']);
          websiteComponentList.push(subpage['component']);
        })
      }
    
  })

//console.log(websitePageList);
//console.log(websiteComponentList);

// server request for availables datasets 
// build Route with DatasetPage
class App extends React.Component {
  constructor(props){
    super(props)
    this.fetchData = this.fetchData.bind(this)
    this.dataSim = []
    this.dataExp = []
    this.state = {"update":false}
    // fetch on constructor
    //this.fetchData("challenge2016")
  }

  render () {
    return (
      <Router history={history}>
        <EpflHeader website={website} history={history}/>
          <div style={{"marginLeft":"100px","marginRight":"100px"}} >
            <Switch>
              <Route exact path="/" component={HomePage} key="Home" />
              {websitePageList.map((page,i) => {
                  return <Route exact path={page} 
                  component={COMPONENT_MAP[websiteComponentList[i]]} 
                  key={i}  history={history}/> 
                })}
              {/*this.dataSim.map((d,i) => {
                  return <Route exact path={"/Datasets/"+d["name"]} 
                  render= { () => <DatasetPage data={d} type="challenge2016"/>} />
                })*/}
              <Route exact path={"/Datasets"} component={Datasets}/>
              <Route exact path={"/TestFlask"} component={TestFlask}/>
              <Route strict path={"/DatasetPage"} component={DatasetPage} history={history}/>
              <Route strict path={"/ChallengeSoftwareInfo"} component={ChallengeSoftwareInfo} history={history} />
              <Route strict path={"/ChallengeSoftwareResults"} component={ChallengeSoftwareResults} history={history} />
              <Route component={NotFound} />
            </Switch>
          </div>
          <Feedback history={history}/>
        <EpflFooter/>
      </Router>
    )
  }

  // fetch the list of jsons from server
  fetchData(name){
    const data = new FormData();
    data.append('name',name);
    const fetchPath = "./../cgi-bin/getDatasetsJSON.py"
    fetch(fetchPath,
    {
        method: 'post',
        headers: {"Accept": "application/text"},
        mode: 'same-origin',
        body: data
    }).then (response => {
        if (response.ok) {
          response.json().then((r) => {
            if (name === "challenge2016") {
              this.dataSim = r
            }
            else {
              this.dataExp = r
            }
            this.setState({update:!this.state.update})
          })
        }
    })
  }
}

export default App;

